import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import DistributorCreate from './DistributorCreate';
import Distributor from './DistributorMain';
import DistributorView from './DistributorView';

class DistributorRoot extends PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired
  };

  render() {
    const { match } = this.props;
    return (
      <div className="entity-wrapper mt-3">
        <Switch>
          <Route exact path={match.path} component={Distributor} />
          <Route exact path={`${match.path}/create`} component={DistributorCreate} />
          <Route exact path={`${match.path}/:id`} component={DistributorView} />
        </Switch>
      </div>
    );
  }
}

export default DistributorRoot;
